import Service from "../../../Service";
import Axios from "../../../Config/API";
import { IDocumentoProduto } from "../../../../Interfaces/Geral/Documentos/DocumentoProduto/DocumentoProdutoInterfaces";

export async function ListarDocumentosProdutoService(
    idProduto: number,
    FL_DOCUMENTO_FILHO?: boolean
) {
    const urlParams = new URLSearchParams();
    urlParams.append("idProduto", idProduto.toString());
    if (FL_DOCUMENTO_FILHO !== undefined)
        urlParams.append("FL_DOCUMENTO_FILHO", String(FL_DOCUMENTO_FILHO));
    return Service(
        Axios.get<Array<IDocumentoProduto>>(
            "/home/documentoproduto/listardocumentosporproduto?" +
                urlParams.toString()
        )
    );
}
